import React from "react";
import { Container, Box, Typography, Divider, Paper } from "@mui/material";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";

const CancellationRefundPolicy = () => {
  return (
      <JumboCardQuick wrapperSx={{ pt: 0 }}>
          <Typography
            variant="h3"
            align="center"
            gutterBottom
            sx={{ fontWeight: 700, my: 4, color: "text.primary" }}
          >
            Cancellation, Refund Policy and Terms
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              1. No Refund for Opt-Outs
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              If you decide to opt out of your subscription, please note that the
              company will not issue any refunds. Once you have committed to a
              subscription and made the payment, it is considered final. In the
              event of an abrupt shutdown, CodingPal.org will not be obligated to
              provide refunds for any fees, subscriptions, or payments made by
              users. This includes, but is not limited to, payments for
              CodingPal.org subscriptions, course fees, and any other paid
              services. We do not allow cancellations of subscriptions once they
              have been activated. This policy is in place to ensure fairness and
              consistency for all our users.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              2. Liability Limitation
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              CodingPal.org will not be liable for any direct, indirect,
              incidental, consequential, or punitive damages arising out of the
              use or inability to use our services in the event of an abrupt
              shutdown. This limitation of liability applies to all users,
              including those with paid subscriptions.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              3. Legal Actions
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              We reserve the right to pursue legal actions against accounts that
              have been blacklisted for serious violations. This includes, but is
              not limited to, fraud, abuse, or any other activities that harm the
              service or other users.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              4. Multiple IP Usage
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              Accounts that are found to be accessed from an excessive number of
              different IP addresses will be suspended without a refund. This
              measure is to prevent misuse and protect the integrity of our
              services.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              5. Serious Actions for Blacklisted Accounts
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              Accounts that are blacklisted due to violations of our terms and
              conditions will face serious consequences. These may include
              permanent suspension and further actions to prevent any future
              misuse and protect the integrity of our services.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              6. Notification
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              If you decide to opt out of your subscription, please note that the
              company will not issue any refunds. Once you have committed to a
              subscription and made the payment, it is considered final.
            </Typography>
          </Box>
      </JumboCardQuick>
  );
};

export default CancellationRefundPolicy;